import React from 'react';
import Axios from 'axios';
import moment from 'moment';


const USE_LOOKUP_DATES = false;

// matching scoresheetId and dates
const DATES_LOOKUP_TABLE = {
"582a15b5cc3c2f61fa6f9d21": "2016-09-28",
"582a1ac1cc3c2f61fa6f9d75": "2016-09-28",
"582a1bb5cc3c2f61fa6f9dfb": "2016-09-28",
"582a1c4ecc3c2f61fa6f9ea9": "2016-09-28",
"582a1d15cc3c2f61fa6f9f7f": "2016-09-28",
"582a1debcc3c2f61fa6fa07d": "2016-09-28",
"582a19decc3c2f61fa6f9d46": "2016-09-28",
"582a1b29cc3c2f61fa6f9db8": "2016-09-28",
"582a1c03cc3c2f61fa6f9e52": "2016-09-28",
"582a1c8dcc3c2f61fa6f9f14": "2016-09-28",
"582a1d61cc3c2f61fa6f9ffe": "2016-09-28",
"582a1e82cc3c2f61fa6fa110": "2016-09-28",
"582a21a6cc3c2f61fa6fa390": "2016-10-05",
"582a226bcc3c2f61fa6fa5d2": "2016-10-05",
"582a230bcc3c2f61fa6fa818": "2016-10-05",
"582a23ffcc3c2f61fa6faa64": "2016-10-05",
"582a2497cc3c2f61fa6facae": "2016-10-05",
"582a2525cc3c2f61fa6faefe": "2016-10-05",
"582a275ecc3c2f61fa6fb256": "2016-10-05",
"582a215acc3c2f61fa6fa278": "2016-10-05",
"582a221fcc3c2f61fa6fa4b1": "2016-10-05",
"582a22b0cc3c2f61fa6fa6f5": "2016-10-05",
"582a238ecc3c2f61fa6fa93f": "2016-10-05",
"582a2452cc3c2f61fa6fab89": "2016-10-05",
"582a24e6cc3c2f61fa6fadd7": "2016-10-05",
"582a2559cc3c2f61fa6fb027": "2016-10-05",
"582a2a27cc3c2f61fa6fb6a9": "2016-10-12",
"582a2ac8cc3c2f61fa6fba1f": "2016-10-12",
"582a2b65cc3c2f61fa6fbd99": "2016-10-12",
"582a2beacc3c2f61fa6fc10f": "2016-10-12",
"582a2c8dcc3c2f61fa6fc48d": "2016-10-12",
"582a2efecc3c2f61fa6fcd55": "2016-10-12",
"582a29c8cc3c2f61fa6fb4ee": "2016-10-12",
"582a2b0ecc3c2f61fa6fbbdc": "2016-10-12",
"582a2b9ecc3c2f61fa6fbf54": "2016-10-12",
"582a2c3fcc3c2f61fa6fc2ce": "2016-10-12",
"582a2cd5cc3c2f61fa6fc64a": "2016-10-12",
"582a2daecc3c2f61fa6fc9c6": "2016-10-12",
"582a297ccc3c2f61fa6fb37d": "2016-10-12",
"582a2a76cc3c2f61fa6fb864": "2016-10-12",
"582a3bf5cc3c2f61fa6fdbc8": "2016-10-19",
"582a3aa7cc3c2f61fa6fd2be": "2016-10-19",
"582a3b50cc3c2f61fa6fd71c": "2016-10-19",
"582a3e6acc3c2f61fa6fe09a": "2016-10-19",
"582a3f4bcc3c2f61fa6fe544": "2016-10-19",
"582a402ecc3c2f61fa6fea36": "2016-10-19",
"582a40d1cc3c2f61fa6fef20": "2016-10-19",
"582a3afccc3c2f61fa6fd4c7": "2016-10-19",
"582a3ba6cc3c2f61fa6fd973": "2016-10-19",
"582a3e16cc3c2f61fa6fde1f": "2016-10-19",
"582a3ee8cc3c2f61fa6fe2ef": "2016-10-19",
"582a3fc2cc3c2f61fa6fe799": "2016-10-19",
"582a408acc3c2f61fa6fec8d": "2016-10-19",
"582a4116cc3c2f61fa6ff18f": "2016-10-19",
"582a60f1cc3c2f61fa6ff9f3": "2016-10-26",
"582a638ecc3c2f61fa700876": "2016-10-26",
"582a643fcc3c2f61fa700e60": "2016-10-26",
"582a64facc3c2f61fa70144a": "2016-10-26",
"582a6593cc3c2f61fa701a34": "2016-10-26",
"582a66a9cc3c2f61fa702306": "2016-10-26",
"582a71dccc3c2f61fa70664b": "2016-10-26",
"582a60b0cc3c2f61fa6ff6c6": "2016-10-26",
"582a615bcc3c2f61fa6ffce6": "2016-10-26",
"582a63e8cc3c2f61fa700b6b": "2016-10-26",
"582a64b0cc3c2f61fa701155": "2016-10-26",
"582a6530cc3c2f61fa70173f": "2016-10-26",
"582a6665cc3c2f61fa701e91": "2016-10-26",
"582a670dcc3c2f61fa70271b": "2016-10-26",
"582a699bcc3c2f61fa702a10": "2016-11-02",
"582a6a68cc3c2f61fa703147": "2016-11-02",
"582a6cf5cc3c2f61fa703947": "2016-11-02",
"582a6dc0cc3c2f61fa70406d": "2016-11-02",
"582a6e60cc3c2f61fa704a59": "2016-11-02",
"582a6f05cc3c2f61fa7051ef": "2016-11-02",
"582a6f8ccc3c2f61fa7059e3": "2016-11-02",
"582a69d9cc3c2f61fa702d54": "2016-11-02",
"582a6ac3cc3c2f61fa703548": "2016-11-02",
"582a6d68cc3c2f61fa703cda": "2016-11-02",
"582a6e01cc3c2f61fa70465a": "2016-11-02",
"582a6eb5cc3c2f61fa704e5a": "2016-11-02",
"582a6f39cc3c2f61fa7055e2": "2016-11-02",
"582a6fd6cc3c2f61fa705d7c": "2016-11-02",
"582a7298cc3c2f61fa7069e2": "2016-11-09",
"582a7328cc3c2f61fa7072ea": "2016-11-09",
"582a73a6cc3c2f61fa707dc4": "2016-11-09",
"582a742bcc3c2f61fa708954": "2016-11-09",
"582a74a4cc3c2f61fa7092e0": "2016-11-09",
"582a753fcc3c2f61fa709bda": "2016-11-09",
"582a7735cc3c2f61fa70a55c": "2016-11-09",
"582a72dacc3c2f61fa706e37": "2016-11-09",
"582a735dcc3c2f61fa707905": "2016-11-09",
"582a73e9cc3c2f61fa708495": "2016-11-09",
"582a7467cc3c2f61fa708e13": "2016-11-09",
"582a74dacc3c2f61fa70979f": "2016-11-09",
"582a76bccc3c2f61fa70a09b": "2016-11-09",
"582a777ccc3c2f61fa70aa11": "2016-11-09",
"582e04293d7d9a7a54b15fc3": "2016-11-16",
"582e045d3d7d9a7a54b16939": "2016-11-16",
"582e04ce3d7d9a7a54b1739f": "2016-11-16",
"582e05773d7d9a7a54b18077": "2016-11-16",
"582e05fd3d7d9a7a54b18add": "2016-11-16",
"582e068f3d7d9a7a54b19761": "2016-11-16",
"582e073f3d7d9a7a54b1a263": "2016-11-16",
"582e04413d7d9a7a54b16454": "2016-11-16",
"582e048a3d7d9a7a54b16e1e": "2016-11-16",
"582e05223d7d9a7a54b17920": "2016-11-16",
"582e05be3d7d9a7a54b1855c": "2016-11-16",
"582e06533d7d9a7a54b1906a": "2016-11-16",
"582e06c13d7d9a7a54b19ce2": "2016-11-16",
"582e07703d7d9a7a54b1a95a": "2016-11-16",
"57e970d291909f538e025035": "2016-09-20",
"57e9711391909f538e025058": "2016-09-20",
"57ec0ce212d5af6dc4929df5": "2016-09-27",
"57ec0d2f12d5af6dc4929e18": "2016-09-27",
"57ec0d8312d5af6dc4929e3b": "2016-09-27",
"57f5a394e743f428d3e872c4": "2016-10-04",
"57f5a3e4e743f428d3e87322": "2016-10-04",
"57f5a518e743f428d3e87380": "2016-10-04",
"57fe7b9de743f428d3e8757c": "2016-10-11",
"57fe7be6e743f428d3e875f9": "2016-10-11",
"57fe7c1de743f428d3e87676": "2016-10-11",
"5835bc56b5d735656e11710f": "2016-10-18",
"582487e2ac46ef255a4d08a6": "2016-10-25",
"581112b34dbc2a1ef1fd654e": "2016-10-25",
"5811135f4dbc2a1ef1fd65e8": "2016-10-25",
"581b26104dbc2a1ef1fd6aed": "2016-11-01",
"581b27c64dbc2a1ef1fd6ba7": "2016-11-01",
"581b28ab4dbc2a1ef1fd6c61": "2016-11-01",
"58233dfde84b867ff989cba7": "2016-11-08",
"58233e6ce84b867ff989cc83": "2016-11-08",
"58233eece84b867ff989cd5f": "2016-11-08",
"582c68573d7d9a7a54b15892": "2016-11-15",
"582c68b33d7d9a7a54b1599f": "2016-11-15",
"582c6bc33d7d9a7a54b15aa0": "2016-11-15",
"5835bcf2b5d735656e11722e": "2016-11-22",
"5835bda9b5d735656e117370": "2016-11-22",
"5835be02b5d735656e1174b2": "2016-11-22",
"57e96b6391909f538e024f5e": "2016-09-14",
"57e96c2191909f538e024f81": "2016-09-14",
"57e96c8a91909f538e024fa4": "2016-09-14",
"57e96ce991909f538e024fc7": "2016-09-21",
"57e96d5491909f538e024fea": "2016-09-21",
"57e96dad91909f538e02500d": "2016-09-21",
"57f2f947e743f428d3e871ef": "2016-09-28",
"57f2f9a3e743f428d3e87258": "2016-09-28",
"580eb35f4dbc2a1ef1fd6481": "2016-09-28",
"57f6a9bce743f428d3e873e4": "2016-10-05",
"57f6aa44e743f428d3e8746a": "2016-10-05",
"57f6aafde743f428d3e874f2": "2016-10-05",
"57ffb47de743f428d3e876f3": "2016-10-12",
"57ffb4f6e743f428d3e8779d": "2016-10-12",
"57ffb557e743f428d3e87847": "2016-10-12",
"5808e4c3569e3c78147912fe": "2016-10-19",
"5808e571569e3c78147913ca": "2016-10-19",
"5808e5bc569e3c7814791496": "2016-10-19",
"5811eeb54dbc2a1ef1fd6822": "2016-10-26",
"5811eefb4dbc2a1ef1fd6910": "2016-10-26",
"5811efb44dbc2a1ef1fd69fe": "2016-10-26",
"581b9a615ecfb0514d690b1c": "2016-11-02",
"581b9b615ecfb0514d690c2d": "2016-11-02",
"581b9c245ecfb0514d690d3f": "2016-11-02",
"5824e8667101a1299703bc5a": "2016-11-09",
"5824e93b7101a1299703bd91": "2016-11-09",
"582d33bc3d7d9a7a54b15ba2": "2016-11-16",
"582d341d3d7d9a7a54b15cfe": "2016-11-16",
"582d34673d7d9a7a54b15e60": "2016-11-16",
};


class TestZone extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			optionSelect: '',
			resultsData: [],
			seekName: ''
		};
	
		this.handleOptionChange = this.handleOptionChange.bind(this);
		this.handleSearchClick = this.handleSearchClick.bind(this);
		this.handleSeekNameChange = this.handleSeekNameChange.bind(this);
		this.createDataRowPMR = this.createDataRowPMR.bind(this);
		this.createDataRowTMR = this.createDataRowTMR.bind(this);
		this.createDataRowGR = this.createDataRowGR.bind(this);
		this.createDataRowSS = this.createDataRowSS.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.loadResults(this.state.optionSelect, this.state.seekName);
	}

	loadResults(statsSelect, seekName) {
		var _this = this;

		// this works fine
		var testDates = false;
		var date1 = moment('2016-10-01').toISOString();
		var date2 = moment('2016-10-15').toISOString();

		if (testDates && (statsSelect === 'playerMatchResults')) {

			Axios.get('/api/results/' + statsSelect + '/date1/' + date1 + '/date2/' + date2).then(function(response) {
				_this.calculateDateAndSetState(statsSelect, response.data);
			});	

		} else if (statsSelect !== '') {

			Axios.get('/api/results/' + statsSelect).then(function(response) {
				_this.calculateDateAndSetState(statsSelect, response.data);
			});	

		}
	}

	calculateDateAndSetState(statsSelect, resultsData) {

		var scoresheetId = '';

		// false: dates are taken from the database collections
		// true:  dates are calculated with the lookup table on top of this file
		if(USE_LOOKUP_DATES) {
			resultsData.forEach(function (resultData) {
				resultData.date = null;
				if(statsSelect === 'scoresheets') {
					scoresheetId = resultData._id;
				} else {
					scoresheetId = resultData.scoresheetId;
				}

				if(scoresheetId !== 0) {
					resultData.date = DATES_LOOKUP_TABLE[scoresheetId];
				}
			});

		} else {
			resultsData.forEach(function (resultData) {
				
				if (resultData.date) {
					//if(resultData._id === "57e96b6391909f538e024f5e") {
					//	console.log(resultData.date);
					//	console.log(moment().utcOffset());
					//}
					resultData.date = moment(resultData.date).utc().format("YYYY-MM-DD");

					//if(resultData._id === "57e96b6391909f538e024f5e") {
					//	console.log(resultData.date);
					//}
				}
			});
		}

		this.setState({
			resultsData: resultsData
		});
	}

/*
  handleGo(e) {
  	var _this = this;
		Axios.post('/api/results/' + _this.state.optionSelect, {
      stats: this.state.resultsData
    })
  }
*/
  render() {
  	var statsHeaderFcn;
  	var statsDataFcn;
  	if (this.state.optionSelect === 'playerMatchResults') {
  		statsHeaderFcn = this.createTrRowPMR();
  		statsDataFcn = this.state.resultsData.map(this.createDataRowPMR);
  	} else if (this.state.optionSelect === 'teamMatchResults') {
  		statsHeaderFcn = this.createTrRowTMR();
  		statsDataFcn = this.state.resultsData.map(this.createDataRowTMR);
  	} else if (this.state.optionSelect === 'gameResults') {
  		statsHeaderFcn = this.createTrRowGR();
   		statsDataFcn = this.state.resultsData.map(this.createDataRowGR);
  	} else if (this.state.optionSelect === 'scoresheets') {
  		statsHeaderFcn = this.createTrRowSS();
   		statsDataFcn = this.state.resultsData.map(this.createDataRowSS);
   	}

    return (
      <div>
	      <h3>TestZone</h3>
  	    <div className="col-md-4">

				<form className="form-inline">
	        <select className="form-control" id='optSelect' value={this.state.optionSelect} onChange={this.handleOptionChange}>
	          <option value={''} key='0'> Choisir une table </option>
	          <option value={'playerMatchResults'} key='1'> playerMatchResults </option>
	          <option value={'teamMatchResults'} key='2'> teamMatchResults </option>
	          <option value={'gameResults'} key='3'> gameResults </option>
	          <option value={'scoresheets'} key='4'> scoresheets </option>
	        </select>
	{/*
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.handleGo}>WRITE</button>
					!!! ATTENTION !!! BOUTON TRÈS DANGEREUX !!!
	*/}
					<br/><br/>
				</form>
        </div>

        <div className="col-md-4">
        </div>
        <br/>

        <div className="col-md-12">
					<h4><b>{this.state.optionSelect}</b></h4>
					<table className="table table-striped table-hover">
					<thead>
						{statsHeaderFcn}
					</thead>
					<tbody>
    	      {statsDataFcn}
					</tbody>
					</table>
        </div>
				<br/>
      </div>
    );
  }

  handleOptionChange(e) {
  	var optionSelect = e.target.value;
  	this.setState({
  		optionSelect: optionSelect,
  		resultsData: []
  	});
		this.loadResults(optionSelect, this.state.seekName);
  }

	handleSeekNameChange(e) {
  	this.setState({
  		seekName: e.target.value,
  	});
	}

	handleSearchClick(e) {
		this.loadResults(this.state.optionSelect, this.state.seekName);
	}

	createTrRowPMR() {
		return (
			<tr key={'rhead'}>
				<th>#</th>
				<th>_id</th>
				<th>seasonId</th>
				<th>subSeasonId</th>
				<th>scoresheetId</th>
				<th>date</th>
				<th>week</th>
				<th>playerId</th>
				<th>playername</th>
				<th>cumulative</th>
			</tr>
		);
	}

	createDataRowPMR(dataItem, dataIdx) { 
		return (
			<tr key={dataIdx}>
				<td>{dataIdx}</td>
				<td>{dataItem._id}</td>
				<td>{dataItem.seasonId}</td>
				<td>{dataItem.subSeasonId}</td>
				<td>{dataItem.scoresheetId}</td>
				<td>{dataItem.date}</td>
				<td>{dataItem.week}</td>
				<td>{dataItem.playerIds[0]}</td>					{/* now array ? */}
				<td>{dataItem.playersName[0]}</td>					{/* now array ? */}
				<td>{dataItem.cumulativeType}</td>
			</tr>
		)
	}

	createTrRowTMR() {
		return (
			<tr key={'rhead'}>
				<th>#</th>
				<th>_id</th>
				<th>seasonId</th>
				<th>subSeasonId</th>
				<th>scoresheetId</th>
				<th>date</th>
				<th>week</th>
				<th>teamId</th>
				<th>teamName</th>
				<th>cumulative</th>
			</tr>
		);
	}

	createDataRowTMR(dataItem, dataIdx) { 
		return (
			<tr key={dataIdx}>
				<td>{dataIdx}</td>
				<td>{dataItem._id}</td>
				<td>{dataItem.seasonId}</td>
				<td>{dataItem.subSeasonId}</td>
				<td>{dataItem.scoresheetId}</td>
				<td>{dataItem.date}</td>
				<td>{dataItem.week}</td>
				<td>{dataItem.teamId}</td>
				<td>{dataItem.teamName}</td>
				<td>{dataItem.cumulativeType}</td>
			</tr>
		)
	}

	createTrRowGR() {
		return (
			<tr key={'rhead'}>
				<th>#</th>
{/*
				<th>_id</th>
				<th>player1</th>
				<th>player2</th>
*/}
				<th>seasonId</th>
				<th>subSeasonId</th>
				<th>scoresheetId</th>
				<th>date</th>
				<th>player1name</th>
				<th>player2name</th>
				<th>player1Score</th>
				<th>player2Score</th>
			</tr>
		);
	}

	createDataRowGR(dataItem, dataIdx) { 
		return (
			<tr key={dataIdx}>
				<td>{dataIdx}</td>
{/*				
				<td>{dataItem._id}</td>
				<td>{dataItem.player1}</td>
				<td>{dataItem.player2}</td>
*/}
				<td>{dataItem.seasonId}</td>
				<td>{dataItem.subSeasonId}</td>
				<td>{dataItem.scoresheetId}</td>
				<td>{dataItem.date}</td>

				<td>{dataItem.player1name}</td>
				<td>{dataItem.player2name}</td>
				<td>{dataItem.player1Score}</td>
				<td>{dataItem.player2Score}</td>
			</tr>
		)
	}

	createTrRowSS() {
		return (
			<tr key={'rhead'}>
				<th>#</th>
				<th>_id</th>
				<th>seasonId</th>
				<th>subSeasonId</th>
				<th>week</th>
				<th>date</th>
				<th>team1Id</th>
				<th>team2Id</th>
				<th>team1Name</th>
				<th>team2Name</th>
			</tr>
		);
	}

	createDataRowSS(dataItem, dataIdx) { 
		return (
			<tr key={dataIdx}>
				<td>{dataIdx}</td>
				<td>{dataItem._id}</td>
				<td>{dataItem.seasonId}</td>
				<td>{dataItem.subSeasonId}</td>
				<td>{dataItem.week}</td>
				<td>{dataItem.date}</td>
				<td>{dataItem.team1Id}</td>
				<td>{dataItem.team2Id}</td>
				<td>{dataItem.team1Name}</td>
				<td>{dataItem.team2Name}</td>
			</tr>
		)
	}

}

export default TestZone;